




















































































import { elapsedTime } from '@/common/util/time';
import CommentOperation from './operation.vue';
import CommentInput from './comment-input.vue';
import commentModel from '../commentModel';
import { defineComponent, computed, ref, Ref } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { useBroadcast } from '@/common/utils';
import { CurrentUserModel } from '@/models/current-user';
import { LoginSource } from '@/common/const';
import Avatar from '@/components/avatar/index.vue';
import { useJumpToProfile, useSendComment } from './utils';
import { useLog } from '@/common/log';
import CommentContent from './comment-content/index.vue';
import SettingEntry from '@/components/business-block/setting-entry/index.vue';
import { debounce } from 'lodash';

export default defineComponent({
    components: {
        Avatar,
        CommentContent,
        CommentOperation,
        CommentInput,
        SettingEntry,
    },
    props: {
        comment: {
            type: Object,
            default: {},
        },
        subComment: {
            type: Object,
            required: true,
        },
        currentWork: {
            type: Object,
            required: true,
        },
        currentAuthor: {
            type: Object,
            required: true,
        },
        canAddComment: {
            type: Number,
        },
        inputPlaceholder: {
            type: String,
        },
        isDark: {
            type: Boolean,
        },
        head: {
            type: Boolean,
            default: true,
        },
        logType: {
            type: String,
        },
    },
    setup(props, { root, emit }) {
        const model = useApolloModel(commentModel);
        const currentUserModel = useApolloModel(CurrentUserModel);
        const isLogin = computed(() => !!currentUserModel?.userInfo.id);
        const currentPage = computed(() => root.$route?.meta?.page);
        const isSendingComment = ref(false);
        const broadcast = useBroadcast();
        const showReplyInput = computed(
            () => props.subComment.commentId === model.replyInputId,
        );
        const elapseTime = elapsedTime({
            begin: new Date(props.subComment.timestamp),
            end: new Date(Math.max(props.subComment.timestamp, +new Date())),
        });
        const log = useLog();
        const reopt: Ref<InstanceType<typeof CommentOperation> | null> = ref(null);
        const sendComment = debounce(async () => {
            if (isSendingComment.value) {
                return;
            }
            isSendingComment.value = true;
            await useSendComment(model, {
                photoId: props.currentWork.id,
                photoAuthorId: props.currentAuthor.id,
                isReplyInput: true,
                replyToCommentId: props.subComment.commentId,
                userInfo: currentUserModel?.userInfo,
                expTag: props.currentWork.expTag,
            }, () => {
                if (!currentUserModel?.userInfo.id) {
                    return broadcast('login', {
                        // 登录源，供日志上报使用
                        source: LoginSource.COMMENT,
                    });
                }
                log({
                    type: 'CLICK',
                    logType: props.logType || null,
                    event_name: 'POST_COMMENT_BUTTON',
                });
            });
            if (model.isBlockedComment) {
                emit('block-comment');
            }
            reopt.value?.restoreState();
            isSendingComment.value = false;
        }, 300);
        return {
            model,
            showReplyInput,
            elapseTime,
            sendComment,
            broadcast,
            currentUserModel,
            useJumpToProfile,
            reopt,
            currentPage,
            isLogin,
        };
    },
});
